import React from 'react';
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Typography } from "@mui/material";
import Div from "@jumbo/shared/Div";

// Los pasos siguen el orden en que se llena PrinterEditModal, para que quien lea
// esto pueda ir completando el formulario sin saltar de un campo a otro.
const PASOS = [
    {
        titulo: 'Instala QZ Tray en el computador',
        detalle: 'Se instala una vez en cada computador desde el que se vaya a imprimir y queda corriendo en segundo plano. Si no está abierto, no sale ninguna etiqueta y "Probar conexión" falla.',
    },
    {
        titulo: 'Crea la impresora y elige el centro',
        detalle: 'Cada impresora pertenece a un centro, y solo aparece al momento de imprimir en ese centro. El nombre es el que verán los usuarios al elegirla.',
    },
    {
        titulo: 'Indica cómo llegar a ella',
        detalle: 'Basta con uno de los dos caminos. Por IP y puerto (9100 es el habitual en las Zebra de red), o por "Nombre en el PC", que es el nombre con el que está instalada en Windows. El nombre es preferible cuando el DHCP le cambia la IP, porque no cambia. El botón "Buscar en este PC" lista las que ve QZ Tray.',
    },
    {
        titulo: 'Prueba la conexión',
        detalle: 'El botón "Probar conexión" consulta el estado de la impresora sin imprimir nada. Si responde, quedó bien configurada.',
    },
    {
        titulo: 'Configura el papel',
        detalle: 'Tamaño en milímetros, resolución en dpi y si es etiqueta troquelada o rollo continuo. Con esos tres datos se arma el ZPL: si no coinciden con el rollo que está cargado, la etiqueta sale corrida o cortada.',
    },
];

const PrintersHelpDialog = ({ isOpen, onClose = () => {} }) => {
    return (
        <Dialog fullWidth maxWidth="sm" open={isOpen} onClose={onClose}>
            <DialogTitle>
                <Typography variant="h2" color="primary">Cómo configurar una impresora</Typography>
            </DialogTitle>

            <DialogContent>
                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Las etiquetas se imprimen desde el computador que tiene la impresora a mano, no
                    desde el servidor. Haulers le manda el trabajo a QZ Tray, que es el programa que
                    hace de puente entre el navegador y la impresora.
                </Typography>

                {PASOS.map((paso, i) => (
                    <Div key={paso.titulo} sx={{ display: 'flex', gap: 1.5, mb: 2 }}>
                        <Typography
                            variant="subtitle2"
                            color="primary"
                            sx={{ flexShrink: 0, minWidth: 20 }}>
                            {i + 1}.
                        </Typography>
                        <Div>
                            <Typography variant="subtitle2">{paso.titulo}</Typography>
                            <Typography variant="body2" color="text.secondary">{paso.detalle}</Typography>
                        </Div>
                    </Div>
                ))}

                <Divider sx={{ my: 2 }} />

                <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                    Una vez creada, la impresora queda disponible al imprimir etiquetas desde Pedidos,
                    Inventario y Bodega. Desactivarla la deja guardada pero fuera de esas listas.
                </Typography>

                <Alert severity="info">
                    Si al imprimir aparece un cartel pidiendo permiso para acceder a las impresoras,
                    es QZ Tray: acéptalo para que el trabajo salga.
                </Alert>
            </DialogContent>

            <DialogActions>
                <Button onClick={() => onClose()}>Cerrar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default PrintersHelpDialog;
